export default "__VITE_ASSET__BALE8qqd__"